// extracted by mini-css-extract-plugin
module.exports = {"config":"costCenter_config__3p3aP","containerConfig":"costCenter_containerConfig__DYdha","form_costCenter":"costCenter_form_costCenter__1Q_Gg"};